export const PERMISSION_CHECKS = 'permissionChecks';

export const PERMISSION_CHECKS_MUTATIONS_NAME = {
  setPermissionCheck: `${PERMISSION_CHECKS}/setPermissionCheck`,
  resetPermissionChecks: `${PERMISSION_CHECKS}/resetPermissionChecks`,
};

export const PERMISSION_CHECKS_ACTIONS_NAME = {
  ensurePermissionChecked: `${PERMISSION_CHECKS}/ensurePermissionChecked`,
  resetPermissionChecks: `${PERMISSION_CHECKS}/resetPermissionChecks`,
};

export const PERMISSION_CHECKS_GETTERS_NAME = {
  getIsHidden: `${PERMISSION_CHECKS}/getIsHidden`,
  getPermissionStatus: `${PERMISSION_CHECKS}/getPermissionStatus`,
};
